<mat-card class="cardWithShadow" style="height: 190px; background:#2641da;">
  <mat-card-header>
    <mat-card-title class="f-s-24 text-white">Performance</mat-card-title>
    <mat-card-subtitle class="f-s-16 text-white">Su anno precedente</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="p-24">
    <div class="d-flex justify-content-between">

      <div class="d-flex align-items-center justify-space-between">
        <span class="d-flex align-items-center gap-8 f-s-30 f-w-bold" style="color: #FFF;">
          <!-- <i-tabler name="mood-smile-beam" style="width: 100px !important; height: 100px !Important;"
        class="icon-50 text-primary d-flex"></i-tabler> -->
        </span>
        <apx-chart [series]="p1Chart.series" [chart]="p1Chart.chart" [plotOptions]="p1Chart.plotOptions"
          [grid]="p1Chart.grid" [tooltip]="p1Chart.tooltip" [colors]="p1Chart.colors" [markers]="p1Chart.markers"
          [legend]="p1Chart.legend" [stroke]="p1Chart.stroke">
        </apx-chart>
        <!-- <span class="d-flex align-items-center gap-8">
            <span class="text-overline">
              <i-tabler name="circle-filled" class="text-accent icon-12 d-flex"></i-tabler>
            </span>
            <span class="font-weight-regular">2020</span>
          </span>
        </div>
        <div class="d-flex align-items-center justify-space-between gap-30 m-t-10">
          <span class="d-flex align-items-center gap-8">
            <span class="text-overline">
              <i-tabler name="circle-filled" class="text-warning icon-12 d-flex"></i-tabler>
            </span>
            <span class="font-weight-regular">2019</span>
          </span>
          <span class="d-flex align-items-center gap-8">
            <span class="text-overline">
              <i-tabler name="circle-filled" class="text-gray-100 icon-12 d-flex"></i-tabler>
            </span>
            <span class="font-weight-regular">2018</span>
          </span> -->
      </div>
      <div class="position-relative"
        style="font-size: 40px;color: #FFF;margin-left: 1px !Important;width: 188px;margin-top: 40px; width: auto;position: absolute;bottom: 0;right: 0;margin: 26px 20px;">
        +27% <mat-icon style="font-size: 42px;height: 35px;width: 50px;">north_east</mat-icon>
      </div>
    </div>
  </mat-card-content>
</mat-card>